module.exports = __webpack_public_path__ + "img/Ford.469fc461.png";